export class AddActionDispatcher {
    static $inject = ['props'];
    constructor(props) {
        Object.assign(this, props);
    }
}
export class AddAction extends AddActionDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super();
        Object.assign(this, props);
    }
}
